export default __webpack_public_path__ + "272d145fe425ffbea0689e9dc0a27bb1.webp";